const COURIER_MOTIVO_KEYS = ["sample", "swatch", "color", "card", "other"];

/** Motivo sample (o legado Matriz). */
export function isCourierSampleMotivo(motivo = "") {
  const m = String(motivo || "")
    .trim()
    .toLowerCase();
  if (!m) return false;
  if (m === "sample") return true;
  if (m.includes("movimiento de muestra")) return true;
  if (m.includes("envío de muestra") || m.includes("envio de muestra")) {
    return true;
  }
  return false;
}

/**
 * Temporada/Marca/… solo con Motivo muestra (o legado Matriz) y código/id.
 * Swatch / color / card / other → ocultos.
 */
export function shouldShowSampleDetails(linea = {}) {
  const m = String(linea.Motivo || "")
    .trim()
    .toLowerCase();
  if (["swatch", "color", "card", "other"].includes(m)) return false;
  if (m && !isCourierSampleMotivo(m)) return false;
  if (!isCourierSampleMotivo(m) && !m) {
    // Motivo vacío: solo si ya viene de Matriz (legado sin Motivo normalizado)
    if (
      !linea.IdMovimientoMuestra &&
      !linea.IdMuestra &&
      !String(linea.CodigoMuestra || "").trim()
    ) {
      return false;
    }
  }
  return Boolean(
    linea.IdMuestra ||
    linea.IdMovimientoMuestra ||
    String(linea.CodigoMuestra || "").trim(),
  );
}

/** Valor de Motivo para el select (legado Matriz → sample). */
export function normalizeCourierMotivoValue(motivo = "") {
  const raw = String(motivo || "").trim();
  if (!raw) return "sample";
  if (COURIER_MOTIVO_KEYS.includes(raw)) return raw;
  if (isCourierSampleMotivo(raw)) return "sample";
  return raw;
}

export function sampleDetailsChanged(linea = {}, fields = {}) {
  const keys = [
    "Temporada",
    "Marca",
    "TipoPrenda",
    "TipoMuestra",
    "Tejido",
    "Color",
    "Talla",
    "CodigoMuestra",
    "IdMuestra",
    "Motivo",
  ];
  return keys.some((k) => String(linea[k] ?? "") !== String(fields[k] ?? ""));
}
